<template>
    <div>
        <h1>{{message}}</h1>
    </div>
</template>


<style scoped>

    .parametre-divers-container {
        background: -webkit-linear-gradient(purple, darkblue);
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 4px;
        font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif
    }

    .general-sous-menu {
        padding: 10px;
        border: 1px groove white;
        margin:5px;
    }
    h1 {
        color: white;
        font-size: 44px;
        text-align:center;
        margin-bottom: 20px;
    }
    #span-sous-menu:hover {
        background: blue;
    }
=======

    h2 {
        color: white;
        font-size: 18px;
        margin-bottom: 10px;
    }

    label, p, span {
        color: white;
    }

    .parametre-divers-container label {
        display: block;
        margin-bottom: 10px;
        color: white;
    }

    .parametre-divers-container input[type="checkbox"] {
        margin-right: 5px;
    }

    .parametre-divers-container input[type="text"] {
        width: 200px;
        padding: 5px;
        border-radius: 4px;
        border: 1px solid #ccc;
        color: #333;
        background-color: white;
    }

    .parametre-divers-container button {
        padding: 8px 12px;
        margin-right: 10px;
        background-color: #3366ff;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s ease;
    }

    .parametre-divers-container button:nth-child(2),
    .parametre-divers-container button:nth-child(3) {
        background-color: #ff3366;
    }

    .parametre-divers-container button:hover {
        background-color: #4d79ff;
    }

    .parametre-divers-container button:nth-child(2):hover,
    .parametre-divers-container button:nth-child(3):hover {
        background-color: #ff6680;
    }
</style>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Divers'
            }
        },
        computed: {
        },
        methods: {
        },
        props: {
        },
        mounted() {
        }

        ,
        created() {
        }
    });
</script>